import React from 'react';
import styled from 'styled-components';
import { Color } from '@/constants/Color';

const Headline = styled.p`
  color: ${Color.secondary};
  font-weight: 700;
  font-size: 17px;
  letter-spacing: 0.04em;
  white-space: pre-line;
  margin: 0;
  padding: 0;

  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
  &.success {
    color: ${Color.success};
  }
  &.danger {
    color: ${Color.danger};
  }
`;

type Props = {
  title?: string;
  align?: string;
  theme?: string;
  children?: React.ReactNode;
};

H2.defaultProps = {
  align: 'left',
  theme: 'secondary',
};

export default function H2(props: Props) {
  return (
    <Headline className={`h2 ${props.align} ${props.theme}`}>
      {props.title}
      {props.children}
    </Headline>
  );
}
